import { render, staticRenderFns } from "./SpecialMealRateApproval.vue?vue&type=template&id=727e398b&scoped=true"
import script from "./SpecialMealRateApproval.vue?vue&type=script&lang=js"
export * from "./SpecialMealRateApproval.vue?vue&type=script&lang=js"
import style0 from "./SpecialMealRateApproval.vue?vue&type=style&index=0&id=727e398b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e398b",
  null
  
)

export default component.exports